
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import wbApi from "../../../API/wbApi";
import { updateFacilityArr } from "../../../redux/actions/FacilityAction";
import { RootState } from "../../../redux/store";
import { CATCH_MESSAGE } from "../../../UtilityFunctions";
import Button from "../../../views/buttons/Button";
import InputTextField from "../../../views/inputfield/InputTextField";



interface IAddFacilitiesSliderProps {
  onClose: () => void;
}
const AddFacilitiesSlider: React.FC<IAddFacilitiesSliderProps> = ({
  onClose,
}) => {

  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);

  const [title, setTitle] = useState('')
  const [loader, setLoader] = useState<boolean>(false);
  const [hotelId, setHotelId] = useState('')
  const [sectId, setSectId] = useState('')
  const [allFacilities, setAllFacilities] = useState([])

  const data = useSelector(
    (state: RootState) => state.facilityData
  );

  const dispatch = useDispatch()

  useEffect(() => {
    if (!data || !data.hotel_id) return


    // setHotelId(data.hotel_id)
    const details = data.facilityArr.filter((obj: any) => {
      if (obj.hotel_id === data.hotel_id) return obj
    })[0]
    // console.log(details, 'to set details')
    if (details) {
      setSectId(details.id)
      setHotelId(details.hotel_id)
      setAllFacilities(details.facilities)
    }
    else {
      setAllFacilities([])
      setHotelId(data.hotel_id)
      setSectId('undefined')
    }
  }, [data])

  const addNewFacility = async () => {
    if (!title) {
      toast.error('Fill all the fields')
    }
    else {
      setLoader(true);
      try {
        const resp = await wbApi.post(`wb/insert-update-wb-facility`, {
          company_id,
          template_id,
          hotel_id: hotelId,
          id: sectId,
          facilities: [...allFacilities, title]
        })

        if (resp.data.status === 1) {
          toast.success(resp.data.message)
          const getResp = await wbApi.get(`wb-dashboard/fetch-wb-facilities-section-details/${company_id}/${template_id}/10`)
          // console.log(getResp.data)
          dispatch(updateFacilityArr(getResp.data.hotel_facilities))
          onClose()
          setLoader(false);
        }
        else {
          toast.error(resp.data.message);
          onClose()
          setLoader(false);
        }
      }
      catch {
        toast.error(CATCH_MESSAGE)
        setLoader(false);
      }
    }
  }

  return (
    <>
      <div className="side__slider__header__label__wrapper">
        <div className="side__slider__close">
          <i className="bi bi-x" onClick={onClose}></i>
        </div>
        <div className="standard-page--label">Add Facility</div>
      </div>
      <div className="height-64px"></div>

      <InputTextField
        label="Facility Title"
        value={title}
        className="description description__slider"
        handleChange={(e) => { setTitle(e.target.value) }}
      />

      <div
        style={{
          width: "100%",
          height: "100px",
          backgroundColor: "white",
        }}
      ></div>

      <div className="side__slider__panel__btn">
        <div className="side__slider__panel__btn_container">
          <Button className="cancel__btn" handleClick={() => onClose()}>Cancel</Button>
          <Button handleClick={() => addNewFacility()} loader={loader}>Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddFacilitiesSlider;
